export function excelFleetReportExpenseColumns() {
  return [
    { key: 'kostnadsart', header: 'Kostnadsart', width: 20 },
    { key: 'description', header: 'Detaljert beskrivelse', width: 30 },
    { key: 'documentNo', header: 'Dokumentnr', width: 15 },
    { key: 'documentType', header: 'Dokumenttype', width: 15 },
    { key: 'termDate', header: 'Terminsdato', width: 20 },
    { key: 'amountIncludingVAT', header: 'Beløp inkl. mva', width: 15 },
  ]
}
